// @ts-nocheck
/* eslint-disable */
export const arrowLeftDoubleFillIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path fill="currentColor" d="m4.03 10 5.172 5.173 1.179-1.179L6.387 10l3.994-3.994-1.179-1.179zm4.708 0 5.173 5.173 1.178-1.179L11.095 10l3.994-3.994-1.178-1.179z"/></svg>`,
    name: 'arrow-left-double-fill' as const
};